import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "reviewStatus",
  class: "form-label"
}, "Status", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Status", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "DR" }, "Reject", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "DA" }, "Accept", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "reviewComment",
  class: "form-label"
}, "Comment", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Save")
], -1)
const _hoisted_12 = { class: "border-bottom mb-3" }
const _hoisted_13 = { class: "mb-3 row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "documentName",
    class: "col-form-label"
  }, "Name:")
], -1)
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = { class: "mb-3 row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "documentDescription",
    class: "col-form-label"
  }, "Description:")
], -1)
const _hoisted_18 = { class: "col-md-8" }
const _hoisted_19 = { class: "mb-3 row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "documentTemplate",
    class: "col-form-label"
  }, "Document Template:")
], -1)
const _hoisted_21 = { class: "col-md-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Without Document Template", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary",
    type: "submit"
  }, "Save")
], -1)
const _hoisted_25 = { class: "border-bottom mb-3" }
const _hoisted_26 = { class: "mb-3 row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "uploadFile",
    class: "col-form-label"
  }, "File:")
], -1)
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary",
    type: "submit"
  }, "Save")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "No", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search pe-1" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "ms-2 filter-description"
}
const _hoisted_33 = { class: "float-end" }
const _hoisted_34 = {
  class: "btn-group position-absolute",
  style: {"top":"-25px","margin-left":"295px"},
  role: "group"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn border border-secondary dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Export ", -1)
const _hoisted_36 = { class: "dropdown-menu" }
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "bi bi-info-circle-fill text-info"
}
const _hoisted_41 = {
  key: 0,
  class: "bi bi-info-circle-fill text-info"
}
const _hoisted_42 = { class: "d-block" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = ["href"]
const _hoisted_45 = { key: 1 }
const _hoisted_46 = ["href"]
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 4 }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 6 }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { key: 1 }

import BTable from "../BTable/BTable.vue";
import BTableHeader from "../BTable/BTableHeader.vue";
import { BTableOptions, BTableColumn } from "../BTable/BTable.types";

import BFilterModal from "../BFilterEditor/BFilterModal.vue";
import InformationModal from "../Misc/InformationModal.vue";

import {
    BFilterOptions,
    describeFilters,
} from "../BFilterEditor/BFilterEditor.types";
import { computed, onMounted, reactive, ref } from "vue";

import type {
    Audit,
    AuditDocument,
    AuditReviewDocument,
    UploadDocumentRequest,
} from "@/audit.types";
import { useAuditDocumentStore } from "@/stores/auditDocumentStore";
import { mixed, number, object, string } from "yup";
import { useFormValidation } from "@/validation";

import TextInput from "../Fields/TextInput.vue";
import TextareaInput from "../Fields/TextareaInput.vue";
import FileInput from "../Fields/FileInput.vue";
import { useAuditDocumentTemplateStore } from "@/stores/auditDocumentTemplateStore";
import { debounce } from "vue-debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditDetailsDocuments',
  props: {
    id: {},
    audit: {},
    runAudits: { type: Boolean },
    createAudits: { type: Boolean }
  },
  setup(__props: any) {

var updateData = debounce(() => getData(), "15000ms");
const auditDocumentStore = useAuditDocumentStore();
const auditDocumentTemplateStore = useAuditDocumentTemplateStore();

const canDelete = computed(() => props.runAudits);
const canRequestDocument = computed(
    () => props.runAudits && props.audit.statusCode != "AC"
);

const props = __props;

const review = ref({} as AuditReviewDocument);

const isShowFilterEditor = ref(false);
const isShowReviewEditor = ref(false);
const isConfirmDialog = ref(false);

const selectedId = ref(0);

const deleteDocumentConfirm = async function (id) {
    isConfirmDialog.value = true;
    selectedId.value = id;
};

const hasAppliedFilters = ref(false);
const columns = reactive<BTableColumn[]>([
    {
        key: "name",
        text: "Name",
        sortable: true,
        value: (item) => item["name"],
    },
    {
        key: "template",
        text: "Template",
        sortable: true,
        value: (item) => item.description,
    },
    {
        key: "status",
        text: "Status",
        sortable: false,
        value: (item) => item["status"],
    },

    {
        key: "agencyAction",
        text: "",
        sortable: false,
        value: (item) => 2,
    },

    {
        key: "actions",
        text: "",
        sortable: false,
        class: (item) => ["text-nowrap text-end"],
        value: (item) => 2,
    },
]);

const item = ref({} as AuditDocument);
const schema = object<AuditDocument>({
    name: string().required().label("Name"),
});

const filtersDescription = computed(() => {
    if (auditDocumentStore.filterOptions == null) {
        return "";
    }
    return describeFilters(
        auditDocumentStore.filterOptions.filters,
        auditDocumentStore.filterableFields
    );
});

const { handleSubmit, errors } = useFormValidation();
const addDocument = async function () {
    if (await handleSubmit(schema, item.value)) {
        item.value.auditId = props.id;
        await auditDocumentStore.create(item.value);
        await getData();
        hideCreateEditor();
    }
};

const deleteDocument = async function () {
    await auditDocumentStore.deleteItem(selectedId.value);
    await getData();
    isConfirmDialog.value = false;
};

const isShowCreateEditor = ref(false);

const showFilterEditor = function (event: any) {
    event.preventDefault();
    isShowFilterEditor.value = true;
};

const handleDismiss = function () {
    isShowFilterEditor.value = false;
};

const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};

const showCreateEditor = function () {
    isShowCreateEditor.value = true;
    item.value = {} as AuditDocument;
    item.value.documentTemplateId = null;
};

const hideUploadDocument = function () {
    isShowUploadDocument.value = false;
};

const isShowUploadDocument = ref(false);
const showUploadDocument = function (id: number) {
    uploadDocumentRequest.value = {} as UploadDocumentRequest;
    uploadDocumentRequest.value.id = id;
    isShowUploadDocument.value = true;
};

const uploadDocumentRequest = ref<UploadDocumentRequest>(
    {} as UploadDocumentRequest
);

const uploadDocumentSchema = object<UploadDocumentRequest>({
    id: number().required(),
    file: mixed().required().label("File"),
});

const uploadDocument = async () => {
    if (await handleSubmit(uploadDocumentSchema, uploadDocumentRequest.value)) {
        await auditDocumentStore.upload(uploadDocumentRequest.value);
        await getData();
        hideUploadDocument();
    }
};

const showReviewEditor = function (id: number) {
    review.value = {} as AuditReviewDocument;
    review.value.id = id;
    review.value.status = null;
    isShowReviewEditor.value = true;
};

const hideReviewEditor = () => {
    isShowReviewEditor.value = false;
};

const reviewSchema = object<AuditReviewDocument>({
    status: string().required().label("Status"),
});
const reviewDocument = async () => {
    if (await handleSubmit(reviewSchema, review.value)) {
        await auditDocumentStore.review(review.value);
        hideReviewEditor();
        await getData();
    }
};

const handleOptionChange = async function (options: BTableOptions) {
    if (options) {
        auditDocumentStore.tableOptions = options;
    }
    await getData();
};

const resetFilters = async function () {
    if (auditDocumentStore.filterOptions != null) {
        auditDocumentStore.filterOptions.filters = [];

        await getData();
    }
    isShowFilterEditor.value = false;
    hasAppliedFilters.value = false;
};
const applyFilters = async function (newFilterOptions: BFilterOptions) {
    auditDocumentStore.filterOptions = newFilterOptions;
    isShowFilterEditor.value = false;
    hasAppliedFilters.value =
        auditDocumentStore.filterOptions.filters.length > 0;

    await getData();
};

const getData = async function () {
    await auditDocumentStore.list(props.id);
    await updateData();
};
onMounted(async () => {
    await getData();
    await auditDocumentTemplateStore.list();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InformationModal, {
      title: "Review Document",
      "show-modal": isShowReviewEditor.value,
      onDismiss: hideReviewEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(reviewDocument, ["prevent"])
        }, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("select", {
                id: "reviewStatus",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((review.value.status) = $event)),
                class: _normalizeClass(["form-select", { 'is-invalid': !!_unref(errors).status}])
              }, _hoisted_7, 2), [
                [_vModelSelect, review.value.status]
              ]),
              (_unref(errors).status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(errors).status), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((review.value.comment) = $event)),
                id: "reviewComment",
                class: "form-control"
              }, "\r\n                    ", 512), [
                [_vModelText, review.value.comment]
              ])
            ])
          ]),
          _hoisted_11
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Request Document",
      "show-modal": isShowCreateEditor.value,
      ref: "createDialog",
      onDismiss: hideCreateEditor
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(addDocument, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(TextInput, {
                  modelValue: item.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.name) = $event)),
                  name: "name",
                  id: "documentName",
                  class: "form-control",
                  error: _unref(errors).name
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(TextareaInput, {
                  id: "documentDescription",
                  modelValue: item.value.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.description) = $event)),
                  class: "form-control",
                  error: _unref(errors).description
                }, null, 8, ["modelValue", "error"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.documentTemplateId) = $event)),
                  id: "documentTemplate",
                  class: "form-select"
                }, [
                  _hoisted_22,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(auditDocumentTemplateStore).items, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.name), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [_vModelSelect, item.value.documentTemplateId]
                ])
              ])
            ])
          ]),
          _hoisted_24
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Upload Document",
      "show-modal": isShowUploadDocument.value,
      onDismiss: hideUploadDocument
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(uploadDocument, ["prevent"])
        }, [
          _createElementVNode("fieldset", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createVNode(FileInput, {
                  modelValue: uploadDocumentRequest.value.file,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((uploadDocumentRequest.value.file) = $event)),
                  name: "uploadFile",
                  error: _unref(errors).file
                }, null, 8, ["modelValue", "error"])
              ])
            ])
          ]),
          _hoisted_29
        ], 32)
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(InformationModal, {
      title: "Delete",
      key: "confirmDialog",
      ref: "confirmDialog",
      "show-modal": isConfirmDialog.value,
      "show-footer": true,
      className: "confirm",
      onDismiss: hideCreateEditor
    }, {
      footer: _withCtx(() => [
        _hoisted_30,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: deleteDocument
        }, "Yes")
      ]),
      default: _withCtx(() => [
        _createTextVNode(" Are You Sure? ")
      ]),
      _: 1
    }, 8, ["show-modal"]),
    _createVNode(BFilterModal, {
      isShowFilterEditor: isShowFilterEditor.value,
      filterOptions: _unref(auditDocumentStore).filterOptions,
      filterableFields: _unref(auditDocumentStore).filterableFields,
      onFilterChanged: applyFilters,
      onDismissModal: handleDismiss
    }, null, 8, ["isShowFilterEditor", "filterOptions", "filterableFields"]),
    _createVNode(BTableHeader, {
      value: _unref(auditDocumentStore).tableOptions,
      onOptionChange: handleOptionChange,
      "header-slot-class": "b-header-slot w-100"
    }, {
      pagingStart: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("ul", _hoisted_36, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: `${_ctx.url}/error-descriptions/download/csv`
                }, "Download as .csv", 8, _hoisted_37)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: `${_ctx.url}/error-descriptions/download/xlsx`
                }, "Download as .xlsx", 8, _hoisted_38)
              ])
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (showFilterEditor($event))),
          type: "button",
          class: "btn btn-primary ml-2"
        }, [
          _hoisted_31,
          _createTextVNode(" Filter ")
        ]),
        _createTextVNode("   "),
        (canRequestDocument.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary",
              onClick: _withModifiers(showCreateEditor, ["prevent"])
            }, "Request Document"))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "header.toolbar"),
        (hasAppliedFilters.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(filtersDescription.value), 1))
          : _createCommentVNode("", true),
        (hasAppliedFilters.value)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "btn-close",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (resetFilters()), ["prevent"]))
            }, null, 512)), [
              [_directive_tooltip, 'Remove all currently applied filters.']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["value"]),
    _createVNode(BTable, {
      items: _unref(auditDocumentStore).items,
      columns: columns,
      caption: '',
      value: _unref(auditDocumentStore).tableOptions,
      onOptionChange: handleOptionChange
    }, {
      "cell.incidentNumber": _withCtx(({ item, column }) => [
        _createElementVNode("span", null, _toDisplayString(item.incidentNumber), 1)
      ]),
      "cell.status": _withCtx(({ item, column }) => [
        _createTextVNode(_toDisplayString(item.status) + " ", 1),
        (item.statusCode!=='DU' && item.statusCode!=='DA')
          ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
              (item.comment)
                ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_40, null, 512)), [
                    [_directive_tooltip, item.comment]
                  ])
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell.name": _withCtx(({ item, column }) => [
        _createTextVNode(_toDisplayString(item.name) + " ", 1),
        (item.description)
          ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_41, null, 512)), [
              [_directive_tooltip, item.description]
            ])
          : _createCommentVNode("", true)
      ]),
      "cell.review": _withCtx(({ item, column }) => []),
      "cell.template": _withCtx(({ item, column }) => [
        (item.documentTemplateFileId)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_42, [
                _createTextVNode(_toDisplayString(item.documentTemplateName) + " ", 1),
                (item.documentTemplateUpdatedOn)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_43, "(Updated at " + _toDisplayString(item.documentTemplateUpdatedOn) + ")", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("a", {
                class: "btn btn-secondary btn-sm mt-2",
                href: `api/v1/audit/file/${item.documentTemplateFileId}`
              }, " View Template ", 8, _hoisted_44)
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_45))
      ]),
      "cell.agencyAction": _withCtx(({ item }) => [
        (item.fileId)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-secondary btn-sm me-2",
              href: `api/v1/audit/file/${item.fileId}`,
              download: ""
            }, " View Document", 8, _hoisted_46))
          : (_openBlock(), _createElementBlock("span", _hoisted_47)),
        (item.statusCode!=='DU' && item.statusCode!=='DA')
          ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
              (item.statusCode=='DN'&& !_ctx.runAudits)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _withModifiers(($event: any) => (showUploadDocument(item.id)), ["prevent"]),
                    class: "btn btn-primary btn-sm me-2"
                  }, " Upload Document ", 8, _hoisted_49))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        ((item.statusCode=='DR'|| item.statusCode=='DU') && !_ctx.runAudits)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              onClick: _withModifiers(($event: any) => (showUploadDocument(item.id)), ["prevent"]),
              class: "btn btn-primary btn-sm me-2"
            }, " Replace Document ", 8, _hoisted_50))
          : (_openBlock(), _createElementBlock("span", _hoisted_51)),
        (_ctx.runAudits && item.statusCode=='DU')
          ? (_openBlock(), _createElementBlock("button", {
              key: 5,
              class: "btn btn-primary btn-sm me-2",
              onClick: _withModifiers(($event: any) => (showReviewEditor(item.id)), ["prevent"])
            }, " Provide Feedback ", 8, _hoisted_52))
          : (_openBlock(), _createElementBlock("span", _hoisted_53))
      ]),
      "cell.actions": _withCtx(({ item }) => [
        (canDelete.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: ($event: any) => (deleteDocumentConfirm(item.id)),
              type: "button",
              class: "btn btn-sm btn-danger"
            }, " Delete ", 8, _hoisted_54))
          : (_openBlock(), _createElementBlock("span", _hoisted_55))
      ]),
      _: 1
    }, 8, ["items", "columns", "value"]),
    _createVNode(BTableHeader, {
      value: _unref(auditDocumentStore).tableOptions,
      onOptionChange: handleOptionChange,
      "header-slot-class": "b-header-slot w-100"
    }, null, 8, ["value"])
  ]))
}
}

})